import React, { memo } from 'react'

import {
  Button, Icon, Close, ArrowLeft, Edit,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'

const closeIcon = <Icon svgComponent={Close} size={iconSize} notSpaced />
const applyIcon = <Icon svgComponent={ArrowLeft} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={Edit} size={iconSize} notSpaced />

function ExpandedImage({ image, onClose, onApply, onEdit }) {
  return (
    <div className="image-assistant-panel__preview">
      <img className="image-assistant-panel__preview-image" src={image.url} alt={image.alt} />
      <Button
        type="secondary"
        variant="only-icon"
        size="tiny"
        icon={closeIcon}
        customClass="image-assistant-panel__preview-close"
        onClick={onClose}
        aria-label="Collapse image"
      />
      <div className="image-assistant-panel__actions">
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={applyIcon}
          onClick={() => onApply(image)}
        >
          Apply and continue
        </Button>
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={editIcon}
          onClick={() => onEdit(image)}
        >
          Edit image
        </Button>
      </div>
    </div>
  )
}

ExpandedImage.propTypes = {
  image: shape({
    id: number.isRequired,
    url: string.isRequired,
    alt: string,
  }).isRequired,
  onClose: func.isRequired,
  onApply: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(ExpandedImage)
